export default __webpack_public_path__ + "static/media/userFocus.02064830.svg";